import {
  Sidebar,
  SidebarInset,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  SidebarProvider,
} from './components/ui/sidebar';
import { SidebarTrigger } from './components/ui/sidebar';
import { Separator } from './components/ui/separator';
import {
  Breadcrumb,
  BreadcrumbSeparator,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
} from './components/ui/breadcrumb';
import { BreadcrumbList } from './components/ui/breadcrumb';
import { Skeleton } from './components/ui/skeleton';
import { TableSkeleton } from './components/common/loading-skeletons/table-skeleton';

function SidebarSkeleton() {
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <Skeleton className="h-10 w-full" />
      </SidebarHeader>
      <SidebarContent>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </SidebarContent>
      <SidebarFooter>
        <Skeleton className="h-10 w-full" />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

export function AppSkeleton() {
  return (
    <div className="animate-in fade-in duration-500 min-h-screen bg-white">
      <SidebarProvider>
        <SidebarSkeleton />
        <SidebarInset>
          <header className="flex h-16 shrink-0 items-center gap-2 border-b">
            <div className="flex items-center gap-2 px-3">
              <SidebarTrigger />
              <Separator orientation="vertical" className="mr-2 h-4" />
              <Breadcrumb>
                <BreadcrumbList>
                  <BreadcrumbItem className="hidden md:block">
                    <BreadcrumbLink href="#">
                      <Skeleton className="h-4 w-24" />
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="hidden md:block" />
                  <BreadcrumbItem>
                    <BreadcrumbPage>
                      <Skeleton className="h-4 w-24" />
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                </BreadcrumbList>
              </Breadcrumb>
            </div>
          </header>
          <TableSkeleton />
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
